import { z } from 'zod'
import { createIncomeSchema } from './create-income.schema'

export const updateIncomeSchema = createIncomeSchema.partial().extend({
  // on update an omitted date must leave the stored date unchanged. the base schema defaults
  // date to now (correct for create), and .partial() keeps that default — so a PATCH without a
  // date would silently move the income to today. override it to a plain optional with no default.
  date: z.string().datetime({ offset: true }).optional(),
})

export type UpdateIncomeDto = z.infer<typeof updateIncomeSchema>
